import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Invoices } from "../../../_models/table-models";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-saved-invoices",
    templateUrl: "./saved-invoices.component.html",
    styleUrls: ["./saved-invoices.component.scss"],
})
export class SavedInvoicesComponent implements OnInit {
    searchTerm: string = "";
    invoices: Invoices[] = [];
    allInvoices: Invoices[] = [];
    responseData: any;
    isError: any;
    isEmpty = false;
    loading = true;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    invs: any;
    tempDataset = [];
    sessionExpired = false;
    errorMsg = "";
    confirmDelete: boolean = false;
    deleteSuccess: boolean = false;
    irn: any;

    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };

    getInvoices(data: any) {
        return this.http.post(
            "https://jsw.qa.payex.live/api/dashboard/fetchInvoice",
            data
        );
    }

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    cleanRoute(path: any) {
        this.invoices.forEach((r: any) => {
            for (let key in r) {
                console.log(`${key}: ${r[key]}`);
            }
        });
    }

    loadSavedInvoices() {
        const userData = {
            action: "savedList",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.getInvoices(userData).subscribe(
            (res) => {
                this.loading = false;
                this.deleteSuccess = false;
                this.responseData = res;
                //console.log(this.responseData);
                if (this.responseData.status === "successful") {
                    // console.log("You did it");
                    this.invoices = this.responseData.savedInvoices;
                    this.collectionSize =
                        this.responseData.savedInvoices.length;
                    this.refreshInvoices();
                } else {
                    this.loading = false;
                    this.isEmpty = true;
                    this.deleteSuccess = false;
                }
                // console.log(res);
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
                //console.log(error);
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.loadSavedInvoices();
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    refreshInvoices() {
        this.invs = this.invoices
            .map((po, i) => ({ id: i + 1, ...po }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
    }

    initiateDelete(irn: any) {
        this.irn = irn;
        this.confirmDelete = true;
    }

    deleteSavedInvoice() {
        const userData = {
            irn: this.irn,
            action: "deleteSavedInvoice",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        //this.loading = true;
        this.confirmDelete = false;

        this.getInvoices(userData).subscribe(
            (res) => {
                this.responseData = res;
                //console.log(this.responseData);
                if (this.responseData.status === "successful") {
                    // console.log("You did it");

                    this.loadSavedInvoices();
                    this.deleteSuccess = true;
                    setTimeout(() => {
                        this.deleteSuccess = false;
                    }, 5000);
                } else {
                    console.log(this.responseData);
                    console.log("Error");
                }
                // console.log(res);
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
                //console.log(error);
            }
        );
    }

    cancelDelete() {
        this.confirmDelete = false;
    }

    editInvoice(irn: any) {
        localStorage.setItem("irn", irn);
        this.router.navigate(["/invoice-update/" + irn]);
    }

    editInvoiceNonPo(irn: any) {
        localStorage.setItem("irn", irn);
        this.router.navigate(["/invoice-update-nonpo/" + irn]);
    }
}
